import { create } from 'zustand';
const useDestinationsOutput = create(() => ({
    destinations: {
        youtube: undefined,
        twitch: undefined,
        x: undefined,
        linkedin: undefined,
    },
}));
const reactiveOutput = {
    useDestinations: () => {
        return useDestinationsOutput((state) => state.destinations);
    },
    useDestination: (platform) => {
        return useDestinationsOutput((state) => state.destinations[platform]);
    },
};
export class DestinationsServiceOutput {
    static getReactiveOutput() {
        return reactiveOutput;
    }
    setDestination(platform, state) {
        useDestinationsOutput.setState((prev) => ({
            destinations: {
                ...prev.destinations,
                [platform]: state,
            },
        }));
    }
    updateDestination(platform, patch) {
        useDestinationsOutput.setState((prev) => {
            const existing = prev.destinations[platform];
            if (!existing)
                return prev;
            return {
                destinations: {
                    ...prev.destinations,
                    [platform]: { ...existing, ...patch },
                },
            };
        });
    }
    getDestination(platform) {
        return useDestinationsOutput.getState().destinations[platform];
    }
    getAllDestinations() {
        return useDestinationsOutput.getState().destinations;
    }
}
